import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";

export default function InfoCard({ children }) {
  return (
    <Grid container justifyContent={"center"}>
      <Grid item>
        <Card
          variant={`outlined`}
          sx={{
            backgroundColor: "rgb(254, 193, 63)",
            borderRadius: "20px",
            backgroundImage:
              "radial-gradient(circle, rgb(253, 213, 118), rgb(254, 193, 63))",
            border: "none",
            minWidth: "320px",
            maxWidth: "320px",
            textAlign: "center",
          }}
        >
          <CardContent>{children}</CardContent>
        </Card>
      </Grid>
    </Grid>
  );
}
